import styled, { css } from "styled-components";

export type ButtonVariant = "primary" | "accent" | "ghost" | "soft" | "dark";
export type ButtonSize = "sm" | "md" | "lg";

const sizes = {
  sm: css`padding: 9px 16px; font-size: 14px; border-radius: 12px;`,
  md: css`padding: 14px 20px; font-size: 15.5px; border-radius: 15px;`,
  lg: css`padding: 16px 22px; font-size: 16.5px; border-radius: 16px;`,
};

export const StyledButton = styled.button<{
  $variant: ButtonVariant;
  $size: ButtonSize;
  $full?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  border: none;
  cursor: pointer;
  width: ${(p) => (p.$full ? "100%" : "auto")};
  transition: transform 0.12s ease, filter 0.12s ease;
  -webkit-tap-highlight-color: transparent;
  ${(p) => sizes[p.$size]}

  &:active:not(:disabled) {
    transform: scale(0.975);
  }
  &:disabled {
    cursor: default;
  }

  ${(p) => {
    const { colors: c, gradients: g, shadows: s } = p.theme.tokens;
    switch (p.$variant) {
      case "accent":
        return css`
          background: ${g.accent};
          color: #fff;
          box-shadow: ${s.ctaAccent};
          &:disabled { background: ${c.disabledBg}; box-shadow: none; }
        `;
      case "ghost":
        return css`
          background: ${c.surface};
          color: ${c.teal};
          border: 1.6px solid ${c.teal};
        `;
      case "soft":
        return css`background: ${c.softTeal}; color: ${c.teal};`;
      case "dark":
        return css`background: ${c.ink}; color: #fff;`;
      default: // primary
        return css`
          background: ${g.button};
          color: #fff;
          box-shadow: ${s.cta};
          &:disabled { background: ${c.disabledBg}; box-shadow: none; }
        `;
    }
  }}
`;
